<script>
export default {
    props: {
        defaultState: {
            type: String,
            default: 'show'
        },
        inheritState: {
            type: Boolean,
            default: true
        },
        initialSubState: {
            type: String
        }
    },
    data() {
        return {
            state: this.defaultState,
            subState: this.initialSubState
        }
    },
    watch: {
        initialSubState: function(newSubState) {
            this.subState = newSubState;
        }
    },
    methods: {
        getState() {
            return this.state;
        }
    }
}
</script>